import * as React from 'react';

interface IProps {
  width?: number;
}

export default (props: IProps) => {
  const {width} = props;

  return (
    <svg
      width={width}
      viewBox="0 0 70 70"
      fill="none"
      version="1.1"
      id="svg334"
      xmlns="http://www.w3.org/2000/svg">
      <defs id="defs338" />
      <g id="Icon">
        <circle id="Oval" cx="35" cy="35" r="35" fill="#0088FF" />
        <path
          d="M 30.624973,16.903342 V 30.475835 H 17.5 v 9.048329 h 13.124973 v 13.572493 h 8.750054 V 39.524164 H 52.5 V 30.475835 H 39.375027 V 16.903342 Z"
          fill="#ffffff"
          id="path559"
        />
      </g>
    </svg>
  );
};
